// extracted by mini-css-extract-plugin
export default {"correctness-model":"correctness-model","title":"title","content":"content","ignore-bottom":"ignore-bottom","scrollClass":"scrollClass","footer":"footer","btn":"btn"};